import { render, staticRenderFns } from "./UpdateStatusModal.vue?vue&type=template&id=444f01b8&scoped=true"
import script from "./UpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateStatusModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatusModal.vue?vue&type=style&index=0&id=444f01b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f01b8",
  null
  
)

export default component.exports